// extracted by mini-css-extract-plugin
export default {"wrapper":"Registration_wrapper__-1-Qh","form":"Registration_form__SdLoh","goBack":"Registration_goBack__-opp6"};